import { useParams } from 'react-router-dom';
import ChatBubbleOutline from '../components/icons/ChatBubbleOutline';
import DocumentDuplicateOutline from '../components/icons/DocumentDuplicateOutline';
import EnvelopeOutline from '../components/icons/EnvelopeOutline';
import ShareItem from '../components/ShareItem';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import { useAppContext } from '../context/AppContext';
import { IdeasForPersonResponse, useIdeas } from '../hooks/useIdeas';

function getShareText(response: IdeasForPersonResponse) {
  return `Hier meine Geschenk-Ideen-Sammlung für ${response.person.name}: \n\n${response.ideas
    .map((idea) => `- ${idea.name} ${idea.url ? `(${idea.url})` : ''}`)
    .join('\n')}\n\nVerwalte deine Wünsche und Ideen ganz einfach und kostenlos mit https://mt-bringsl.de`;
}

const ShareIdeasPage = () => {
  const { alertSuccess } = useAppContext();
  const { personId } = useParams();

  const query = useIdeas(personId || '', { refetchOnMount: false, refetchOnWindowFocus: false });

  return (
    <div style={{ margin: '2rem' }} className="space-y-4">
      <Breadcrumbs
        crumbs={[
          { text: 'Ideen', route: '/ideas' },
          { text: query.data?.person.name || 'Person', route: '/ideas/' + personId },
          { text: 'Teilen', route: `/ideas/${personId}/share` },
        ]}
      />
      <h1 className="text-white text-xl">
        <b>Ideen für {query.data?.person.name} teilen</b>
      </h1>
      <p className="text-white">Hier kannst du deine Ideen für {query.data?.person.name} mit deinen Freunden teilen:</p>
      <div className="grid grid-cols-3 md:grid-cols-4 gap-6 max-w-sm pt-4">
        <ShareItem
          name="Whatsapp"
          Icon={<ChatBubbleOutline className="w-8 h-8 text-lime-700" />}
          onClick={() => {
            if (!query.data) return;
            const text = getShareText(query.data);
            const params = new URLSearchParams('');
            params.append('text', text);
            const url = `https://wa.me?${params.toString()}`;
            window.open(url, '_blank');
          }}
        />
        <ShareItem
          name="Email"
          Icon={<EnvelopeOutline className="w-8 h-8 text-gray-700" />}
          onClick={() => {
            if (!query.data) return;
            const text = getShareText(query.data).replaceAll('\n', '%0D%0A');
            const url = `mailto:?to=&subject=Geschenk-Ideen-Sammlung für ${query.data?.person.name}&body=${text}`;
            window.open(url, '_blank');
          }}
        />
        <ShareItem
          name="Text"
          Icon={<DocumentDuplicateOutline className="w-8 h-8 text-gray-700" />}
          onClick={() => {
            if (!query.data) return;
            const text = getShareText(query.data);
            navigator.clipboard.writeText(text);
            alertSuccess('Text in die Zwischenablage kopiert.');
          }}
        />
      </div>
    </div>
  );
};

export default ShareIdeasPage;
